<template>
  <div class="footerBar">
    <img src="../../assets/images/footer_logo.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "footerBar",
  components: {},
};
</script>
<style scoped>
.footerBar {
  position: fixed;
  width: 100%;
  height: 34px;
  left: 0;
  bottom: 5px;
  z-index: 10;
  text-align: center;
  padding: 10px 0;
}
.footerBar img {
  height: 34px;
  width: auto;
}
</style>